import { render, staticRenderFns } from "./detailPure_m.vue?vue&type=template&id=dfb09c66&scoped=true"
import script from "./detailPure_m.vue?vue&type=script&lang=js"
export * from "./detailPure_m.vue?vue&type=script&lang=js"
import style0 from "./detailPure_m.vue?vue&type=style&index=0&id=dfb09c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb09c66",
  null
  
)

export default component.exports